import React from 'react'

import { collaborateList } from '../common/Helper'
import PrimaryHeading from '../custom-ui/PrimaryHeading'

const Collaborate = () => {
  return (
    <div className=" container py-24">
      <PrimaryHeading class="leading-[111%]">
        {' '}
        Collaborate with confidence
      </PrimaryHeading>
      <div className="flex flex-wrap items-center justify-around gap-y-6 pt-10 md:gap-y-10">
        {collaborateList.map((obj, index) => (
          <div
            key={index}
            className="flex h-[200px] w-full max-w-[320px] flex-col items-center justify-center rounded-md px-3 py-3 text-center transition-all duration-300"
          >
            {obj.icon}
            <h3 className=" text-3xl font-semibold leading-120 tracking-4xl text-night-black">
              {obj.title}
            </h3>
            <p className="common-pera">{obj.Info}</p>
          </div>
        ))}
      </div>
    </div>
  )
}

export default Collaborate
